import { tokens } from 'styling/tokens'
import { IGetAllResourceBookingsSingleResponse } from 'types/api/operationsBookingApi.interface'

export const resourceTypes = [
  { label: 'Worker', value: 1 },
  { label: 'Machine', value: 2 },
]

export const resourceTypeOptions = [
  { label: 'Worker', value: 1 },
  { label: 'Machine', value: 2 },
]

export const holderTypes = [
  { label: 'Plan', value: 1 },
  { label: 'Phase', value: 2 },
  { label: 'Cycle', value: 3 },
  { label: 'Workflow', value: 4 },
  { label: 'Shift Program', value: 5 },
  { label: 'Task', value: 6 },
  { label: 'Manual', value: 7 },
]

export const holderTypeOptions = [
  { label: 'Plan', value: 1 },
  { label: 'Shift Program', value: 5 },
]

export const bookingPriorities = [
  { label: 'Low', value: 1 },
  { label: 'Normal', value: 2 },
  { label: 'High', value: 3 },
  { label: 'Critical', value: 4 },
]

export const bookingStatuses = [
  { label: 'Active', value: 1, color: tokens.status.success.fg, tone: 'success' as const },
  { label: 'Released', value: 0, color: tokens.text.muted, tone: 'neutral' as const },
]

export const getResourceLabel = (item: IGetAllResourceBookingsSingleResponse) => {
  if (item.resourceType === 1) {
    return item.resourceWorker
      ? `${item.resourceWorker.firstName} ${item.resourceWorker.lastName}`
      : '-'
  }
  return item.resourceMachine?.name || '-'
}

export const getHolderLabel = (item: IGetAllResourceBookingsSingleResponse) => {
  if (item.holderType === 1) return item.holderPlan?.name || '-'
  if (item.holderType === 5) return item.holderShiftProgram?.name || '-'
  return '-'
}

const hoursAgo = (h: number) => new Date(Date.now() - h * 3600000).toISOString()
const hoursFromNow = (h: number) => new Date(Date.now() + h * 3600000).toISOString()

export const DEMO_BOOKINGS: IGetAllResourceBookingsSingleResponse[] = [
  {
    id: 70001,
    resourceType: 2,
    resourceWorker: null,
    resourceMachine: { id: 12, name: 'Truck 07' },
    holderType: 1,
    holderPlan: { id: 90001, name: 'North Pit Extraction Plan', code: 'NPX-001', status: 2 },
    holderPhase: null,
    holderWorkflow: null,
    holderShiftProgram: null,
    holderTask: null,
    priority: 3,
    startAt: hoursAgo(4),
    endAt: hoursFromNow(8),
    isActive: true,
    createdAt: hoursAgo(20),
    updatedAt: hoursAgo(4),
  },
  {
    id: 70002,
    resourceType: 1,
    resourceWorker: { id: 41, firstName: 'Daniel', lastName: 'R.' },
    resourceMachine: null,
    holderType: 5,
    holderPlan: null,
    holderPhase: null,
    holderWorkflow: null,
    holderShiftProgram: { id: 80007, name: 'Camp Cleaning', status: 1 },
    holderTask: null,
    priority: 2,
    startAt: hoursAgo(2),
    endAt: hoursFromNow(6),
    isActive: true,
    createdAt: hoursAgo(26),
    updatedAt: hoursAgo(2),
  },
  {
    id: 70003,
    resourceType: 2,
    resourceWorker: null,
    resourceMachine: { id: 15, name: 'Excavator EX-03' },
    holderType: 1,
    holderPlan: { id: 90003, name: 'Block B Drill & Blast', code: 'DBL-014', status: 2 },
    holderPhase: null,
    holderWorkflow: null,
    holderShiftProgram: null,
    holderTask: null,
    priority: 1,
    startAt: hoursAgo(18),
    endAt: hoursAgo(6),
    isActive: false,
    createdAt: hoursAgo(30),
    updatedAt: hoursAgo(6),
  },
]
